import {
  Drawer,
  gap,
  NewTypography as Typography,
  spacing,
} from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

export const Alert = styled(Drawer)``;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${spacing.small};
`;

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${gap(spacing.small)};
`;

type RowProps = {
  full?: boolean;
};

export const Row = styled.div<RowProps>`
  ${({ full = false }) => css`
    width: ${full ? '100%' : 'initial'};
    display: flex;
    flex-direction: row;
    align-items: center;

    ${gap(spacing.small)};
  `};
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const Title = styled(Typography)`
  font-size: 1.4rem;
`;
